export enum RequestType {
    InStock = 'Stock',
    GLP = 'GLP',
    Radioactive = 'Radioactive',
    PeerToPeer = 'P2P',
    Bionexus = 'BIONEXUS'
}